import { ExtensionDataList } from '@teambit/legacy.extension-data';

export class Store extends ExtensionDataList {}
